var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8ZM11.6067 6.89925C11.9742 6.5317 11.9742 5.93578 11.6067 5.56823C11.2391 5.20068 10.6432 5.20068 10.2757 5.56823L7.01961 8.82429L5.72433 7.52901C5.35678 7.16146 4.76086 7.16146 4.39331 7.52901C4.02576 7.89657 4.02576 8.49249 4.39331 8.86004L6.35409 10.8208C6.72165 11.1884 7.31757 11.1884 7.68512 10.8208L11.6067 6.89925Z",
    fill: "#3AAD2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.364bab8d6bf5896e99af68f80966adac.svg";
export { ForwardRef as ReactComponent };